import { MobileTitle, ErrorBox } from './Shared';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import BrandSlider from './BrandSlider';
import HeroArtwork from './HeroArtwork';
import HomeWorkbench from './HomeWorkbench';
import BsiIcon, { buttonIcon, pageIcons } from './BsiIcon';
import { t, text, api, errorText } from '../helpers';
const informationSections = {
  services: ['scope', 'request', 'quote', 'delivery'],
  payment: ['price', 'checkout', 'confirmation', 'help'],
  refund: ['cancellation', 'quality', 'request', 'timing'],
  terms: ['provider', 'agreement', 'deadline', 'delivery', 'files', 'rights'],
  contacts: ['provider']
};
const relatedPages = {
  services: ['payment', 'terms'],
  payment: ['refund', 'contacts'],
  refund: ['contacts', 'terms'],
  terms: ['contacts', 'refund'],
  contacts: []
};
export class HomePage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--bsi BsiHome';
    app.setTitle(text('home.browser_title', {
      brand: app.forum.attribute('title')
    }));
  }
  view() {
    return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("section", {
      className: "Hero BsiHomeHero"
    }, m("div", {
      className: "container BsiHeroGrid"
    }, m("div", {
      className: "BsiHomeHero-content"
    }, m("h1", null, t('home.headline'), m("span", null, t('home.headline_accent'))), m("p", null, t('home.description')), m("div", {
      className: "BsiActions"
    }, app.session.user ? [m(LinkButton, {
      className: "Button Button--primary",
      href: app.route('bsi.orders'),
      icon: buttonIcon('folders')
    }, t('nav.orders')), m(LinkButton, {
      className: "Button BsiHeroSecondary",
      href: app.route('bsi.dashboard'),
      icon: buttonIcon('house')
    }, t('nav.dashboard'))] : [m(Button, {
      className: "Button Button--primary",
      icon: buttonIcon('user-plus'),
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
    }, t('auth.signup')), m(Button, {
      className: "Button BsiHeroSecondary",
      icon: buttonIcon('sign-in'),
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, t('auth.login'))]), m("div", {
      className: "BsiHeroNote"
    }, m(BsiIcon, {
      name: "shield-check"
    }), t('home.account_note')), m("div", {
      className: "BsiJourney"
    }, m("span", {
      className: "BsiJourney-title"
    }, t('home.journey_title')), m("ol", {
      "aria-label": text('home.journey_title')
    }, [['request', 'upload-simple'], ['quote', 'receipt'], ['payment', 'credit-card'], ['result', 'check-circle']].map((_ref, index) => {
      let [step, icon] = _ref;
      return m("li", {
        key: step
      }, m("span", {
        className: "BsiJourney-marker",
        "aria-hidden": "true"
      }, m(BsiIcon, {
        name: icon
      }), m("span", {
        className: "BsiJourney-number"
      }, '0' + (index + 1))), m("span", null, t('home.journey_' + step)));
    })))), m(HeroArtwork, null))), m("div", {
      className: "container"
    }, m(BrandSlider, null), m("section", {
      className: "BsiFeatures",
      "aria-label": text('home.services_label')
    }, [['cpu', 'units'], ['file-code', 'individual'], ['user-check', 'quote'], ['folders', 'history']].map(_ref2 => {
      let [icon, key] = _ref2;
      return m("div", {
        className: "BsiFeature",
        key: key
      }, m("span", {
        className: "BsiFeature-icon"
      }, m(BsiIcon, {
        name: icon
      })), m("h2", null, t('home.' + key + '_title')), m("p", null, t('home.' + key + '_text')));
    })), m(HomeWorkbench, null)));
  }
}
export class InfoPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--bsi';
    this.section = this.attrs.section;
    app.setTitle(text('public.' + this.section + '.title'));
    if (this.section === 'contacts') {
      this.robots = document.querySelector('meta[data-bsi-provider-robots]') || document.createElement('meta');
      this.robots.name = 'robots';
      this.robots.content = 'noindex, nofollow, noarchive, nosnippet';
      this.robots.dataset.bsiProviderRobots = '1';
      document.head.appendChild(this.robots);
      this.details = app.data.bsiContactDetails || null;
      delete app.data.bsiContactDetails;
      if (!this.details) {
        this.loading = true;
        api('/provider-details').then(response => {
          if (!this.removed) this.details = response.data;
        }).catch(error => {
          if (!this.removed) this.error = errorText(error);
        }).finally(() => {
          if (!this.removed) {
            this.loading = false;
            m.redraw();
          }
        });
      }
    }
  }
  onremove(vnode) {
    this.removed = true;
    this.robots?.remove();
    this.details = null;
    super.onremove(vnode);
  }
  view() {
    const section = this.section;
    return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("div", {
      className: "container"
    }, m("article", {
      className: 'BsiArticle BsiArticle--' + section
    }, m("header", {
      className: "BsiArticle-heading"
    }, m("span", {
      className: "BsiArticle-icon"
    }, m(BsiIcon, {
      name: pageIcons[section]
    })), m("div", null, m("span", {
      className: "BsiEyebrow"
    }, "BSI.by"), m("h1", null, t('public.' + section + '.title')))), m("div", {
      className: "BsiArticle-body"
    }, m("p", null, t('public.' + section + '.intro')), informationSections[section].map(key => m("section", {
      className: "BsiArticle-section",
      key: key
    }, m("h2", null, t('public.' + section + '.' + key + '_title')), m("p", null, t('public.' + section + '.' + key + '_text')))), section === 'contacts' && this.contactDetails(), ['terms', 'refund'].includes(section) && m("p", {
      className: "BsiArticle-source"
    }, m("a", {
      href: "https://etalonline.by/document/?regnum=h10200090"
    }, t('public.consumer_law'))), relatedPages[section].length > 0 && m("div", {
      className: "BsiActions BsiArticle-related"
    }, relatedPages[section].map(page => m(LinkButton, {
      key: page,
      className: "Button Button--link",
      href: app.route('bsi.' + page),
      icon: buttonIcon(pageIcons[page])
    }, t('public.' + page + '.title'))))), m(LinkButton, {
      className: "Button Button--link BsiArticle-back",
      href: app.route('index'),
      icon: buttonIcon('arrow-left')
    }, t('common.back_home')))));
  }
  contactDetails() {
    if (this.loading) return m(LoadingIndicator, null);
    if (this.error) return m(ErrorBox, {
      error: this.error
    });
    const contactFields = [['legal_name', 'legal_name'], ['legal_unp', 'legal_unp'], ['contacts_email', 'email'], ['contacts_phone', 'phone'], ['contacts_hours', 'hours'], ['contacts_address', 'address'], ['legal_details', 'legal_details']];
    return m("dl", {
      className: "BsiDetails",
      "data-nosnippet": "true"
    }, contactFields.filter(_ref3 => {
      let [field] = _ref3;
      return this.details?.[field];
    }).map(_ref4 => {
      let [field, label] = _ref4;
      const value = this.details[field];
      return m("div", {
        key: field
      }, m("dt", null, t('contacts.' + label)), m("dd", null, label === 'email' ? m("a", {
        href: 'mailto:' + value
      }, value) : label === 'phone' ? m("a", {
        href: 'tel:' + value
      }, value) : value));
    }));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/PublicPages', { HomePage: HomePage,InfoPage: InfoPage, });